import {
  BarChart3,
  Users,
  Settings,
  Home,
  PieChart,
  FileText,
  MessageSquare,
  LayoutDashboard,
} from 'lucide-react'
import { cn } from '@/lib/utils'

export const Sidebar = () => {
  const menuItems = [
    { icon: Home, label: 'Visão Geral', active: true },
    { icon: BarChart3, label: 'Analítica' },
    { icon: Users, label: 'Clientes' },
    { icon: FileText, label: 'Relatórios' },
    { icon: MessageSquare, label: 'Mensagens' },
    { icon: PieChart, label: 'Orçamento' },
  ]

  return (
    <div className="w-14 md:w-56 border-r border-slate-200/60 bg-white/50 hidden sm:flex flex-col py-4 gap-2 z-10">
      <div className="px-4 mb-4 flex items-center gap-2">
        <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
          <LayoutDashboard className="w-5 h-5 text-primary" />
        </div>
        <span className="hidden md:block font-bold text-sm text-slate-800">
          Núcleo
        </span>
      </div>

      <div className="flex-1 px-2 space-y-1">
        {menuItems.map((item, i) => (
          <div
            key={i}
            className={cn(
              'flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-all duration-200 group cursor-default',
              item.active
                ? 'bg-white shadow-sm ring-1 ring-slate-200/50 text-primary font-medium'
                : 'text-slate-500 hover:bg-white/40 hover:text-slate-900',
            )}
          >
            <item.icon
              className={cn(
                'w-4 h-4',
                item.active
                  ? 'text-primary'
                  : 'text-slate-400 group-hover:text-slate-600',
              )}
            />
            <span className="hidden md:block">{item.label}</span>
          </div>
        ))}
      </div>

      <div className="px-2 mt-auto">
        <div className="flex items-center gap-3 px-3 py-2 rounded-md text-sm text-slate-500 hover:bg-white/40 hover:text-slate-900 cursor-default transition-colors">
          <Settings className="w-4 h-4 text-slate-400" />
          <span className="hidden md:block">Definições</span>
        </div>
      </div>
    </div>
  )
}
